
import {
  defineComponent, ref, SetupContext, watch, onMounted, PropType, computed,
} from 'vue';
import BaseInputText from '@/components/fields/BaseInputText.vue';
import allVariables from '@/components/template-builder/utils/variables-list';
import { getCustomContactProperties } from '@/configs/custom-contact-properties';
import { getMetadataVariables } from '@/composables/template-builder/collectionContext';
import { store } from '@/store';

export default defineComponent({
  name: 'SegmentInputText',

  components: {
    BaseInputText,
  },

  props: {
    modelValue: {
      type: String,
      required: true,
    },

    availableContexts: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => ['contact'],
    },
  },

  emits: ['update:modelValue'],

  setup(props: { modelValue: string; availableContexts: string[] }, { emit }: SetupContext) {
    const value = ref(props.modelValue);
    const variablesList = ref<any[]>([]);

    // Get originCall from store instead of prop
    const originCall = computed(() => store.getters['segmentationsEditor/getOriginCall']);

    watch(value, () => {
      emit('update:modelValue', value.value);
    });

    onMounted(async () => {
      // Filter variables based on available contexts
      const filteredVariables = allVariables.allVariables.filter((variable) => {
        const varValue = variable.value;

        // Check if the variable matches any of the available contexts
        return props.availableContexts.some((context) => varValue.includes(`${context}.`));
      });

      let baseVariables: any[] = [...filteredVariables];

      // Add custom contact properties
      try {
        const customSchemas = await getCustomContactProperties();
        const customVariables = customSchemas.flatMap((schema) => schema.properties.map((prop) => ({
          value: `{var=${prop.variableName}}`,
          label: `${schema.schemaName} - ${prop.name}`,
          labelWithBadge: `${schema.schemaName} - ${prop.name} <span class="custom-badge-inline">CUSTOM</span>`,
          type: prop.type,
          isCustom: true,
        })));
        baseVariables = [...baseVariables, ...customVariables];
      } catch (error) {
        console.error('Error loading custom contact properties:', error);
      }

      // Add metadata variables from custom events
      try {
        const metadataVars = await getMetadataVariables();
        baseVariables = [...baseVariables, ...metadataVars];
      } catch (error) {
        console.error('Error loading metadata variables:', error);
      }

      variablesList.value = baseVariables;
    });

    return {
      value,
      variablesList,
      originCall,
    };
  },
});
